import { css } from '@linaria/core';
import { breakpoints } from 'styles/utils';
import { chatScrollArea } from './ChatUI';
import { container } from './ChatPlaceholder';
import { styles as contentHeaderStyle } from './PlaygroundContentHeader/PlaygroundContentHeader';
import { playgroundLeftHeader, playgroundSelectorWrapper } from './PlaygroundHeader.styled';
import { ComboboxContainerStyle } from './Selector';
export const styles = {
  playgroundContainer: "odules__Playground__Components__PanelManager_styled_tsx-playgroundContainer-p1ake9c8",
  compareContainer: "odules__Playground__Components__PanelManager_styled_tsx-compareContainer-c1p1zmpt",
  comparePanel: "odules__Playground__Components__PanelManager_styled_tsx-comparePanel-cb32cph",
  comparePanelContent: "odules__Playground__Components__PanelManager_styled_tsx-comparePanelContent-c1xiu3ns"
};

// Override styles for compare mode - these styles will be applied when [data-mode='compare'] is present
export const compareOverrides = "odules__Playground__Components__PanelManager_styled_tsx-compareOverrides-cbzfgrk";

require("./PanelManager.styled.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./PanelManager.styled.tsx");